import api from "../services/axios";

/**
 * Polls an API until status is not "pending"/"in_progress",
 * but only if the user stays on the same URL.
 *
 * @param {string} url - API endpoint
 * @param {number} intervalMs - Poll interval (default 3s)
 * @param {number} timeoutMs - Max time before auto stop (default 2min)
 * @returns {Promise<object>} Resolves with final API response
 */
export const pollAttemptApiUntilComplete = (url, intervalMs = 2000, timeoutMs = 120000) => {
    return new Promise((resolve, reject) => {
        const startTime = Date.now();
        const currentUrl = window.location.href; // snapshot current page

        const interval = setInterval(async () => {
            try {
                // stop if user navigated away
                if (window.location.href !== currentUrl) {
                    clearInterval(interval);
                    reject(new Error("User navigated away, polling stopped"));
                    return;
                }

                const { data } = await api.get(url);

                if (!['pending', 'processing'].includes(data?.data?.transcription_status)) {
                    clearInterval(interval);
                    resolve(data?.data);
                }

                if (Date.now() - startTime >= timeoutMs) {
                    clearInterval(interval);
                    reject(new Error("Polling timed out"));
                }
            } catch (error) {
                clearInterval(interval);
                reject(error instanceof Error ? error : new Error(error));
            }
        }, intervalMs);
    });
};

